module.exports = __webpack_public_path__ + "img/bayer_genuine_aspirin.3d788e6f.jpg";